import React, { useMemo } from 'react';
import { clsx } from '@core/js/utils/classNames.util';
import { pick } from 'ramda';
import { Control } from '@theme/js/components/common/Fields/Control';
import { withField } from '@core/js/components/common/Fields/withField';

import { CheckboxShallow } from '@core/js/components/common/Fields/Checkbox/components/CheckboxShallow';

import style from './Checkbox.scss';

// todo checkbox group (with rff)
// todo checkbox HOC with positive/negative values (much later - for reg builder)

export const CheckboxBare = ({
    /* rff render props */
    input,
    meta = {},

    /* user provided props */
    id,
    name,
    label,
    labelTop,
    hint,
    hintTop,
    controlMultiselect, /* TotalCasino changes */
    className = '',
    classNames: classNamesProps,
    onClick,
    itemRef,
    isLabelAsteriskEnabled,

    ...checkboxDomProps
}) => {
    const classNames = useMemo(
        () => ({ ...classNamesProps, ...pick(['content', 'hint'], style) }),
        [classNamesProps]
    );

    /* TotalCasino changes */
    const classNamesControl = useMemo(() => {
        const classProps = pick(['hint'], style);
        return {
            ...classNamesProps,
            ...classProps,
            content: clsx([style.content, classNamesProps && classNamesProps?.content])
        };
    }, [classNamesProps]);
    /* TotalCasino changes */

    return (
        <Control
            id={id}
            meta={meta}
            onClick={onClick}
            label={labelTop}
            hint={hintTop}
            animate={true}
            /* TotalCasino changes */
            classNames={classNamesControl}
            className={`${className} ${controlMultiselect ? style.controlMultiselect : style.control}`}
        >
            <CheckboxShallow
                id={id}
                label={label}
                hint={hint}
                name={name}
                itemRef={itemRef}
                classNames={classNames}
                {...input}
                {...checkboxDomProps}
                {...meta.submitting ? { disabled: true } : {}}
                isLabelAsteriskEnabled={isLabelAsteriskEnabled}
            />
        </Control>
    );
};

export const withCheckbox = Wrapped => props => <Wrapped {...{
    ...props,
    type: 'checkbox' // it is required for rff `Field` to know how to unpack `value`
}} />;

export const Checkbox = withCheckbox(withField(CheckboxBare));
